import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

// Lazy load pages
const HomePage = lazy(() => import('../pages/home/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const KVKKPage = lazy(() => import('../pages/kvkk/page'));

// Fiber Services
const FiberServicesPage = lazy(() => import('../pages/fiber-services/page'));
const FiberCableRepairPage = lazy(() => import('../pages/fiber-services/fiber-cable-repair/page'));
const FiberTerminationPage = lazy(() => import('../pages/fiber-services/fiber-termination/page'));
const OTDRTestPage = lazy(() => import('../pages/fiber-services/otdr-test/page'));
const BuildingFiberPage = lazy(() => import('../pages/fiber-services/building-fiber/page'));
const FactoryFiberPage = lazy(() => import('../pages/fiber-services/factory-fiber/page'));
const EmergencyServicePage = lazy(() => import('../pages/fiber-services/emergency-service/page'));

// Security Systems
const SecuritySystemsPage = lazy(() => import('../pages/security-systems/page'));
const IPCameraSystemsPage = lazy(() => import('../pages/security-systems/ip-camera-systems/page'));
const BurglarAlarmSystemsPage = lazy(() => import('../pages/security-systems/burglar-alarm-systems/page'));
const FireAlarmSystemsPage = lazy(() => import('../pages/security-systems/fire-alarm-systems/page'));
const AccessControlSystemsPage = lazy(() => import('../pages/security-systems/access-control-systems/page'));
const BarrierSystemsPage = lazy(() => import('../pages/security-systems/barrier-systems/page'));
const TurnstileSystemsPage = lazy(() => import('../pages/security-systems/turnstile-systems/page'));

// Service Projects - YENİ SAYFALAR
const FabrikaFiberAltyapiProjesi = lazy(() => import('../pages/hizmetlerimiz/fabrika-fiber-altyapi-projesi/page'));
const SanayiBolgesiKameraSistemi = lazy(() => import('../pages/hizmetlerimiz/sanayi-bolgesi-kamera-sistemi/page'));
const MetroEthernetFiberEk = lazy(() => import('../pages/hizmetlerimiz/metro-ethernet-fiber-ek/page'));
const BinaYanginAlarmSistemi = lazy(() => import('../pages/hizmetlerimiz/bina-yangin-alarm-sistemi/page'));
const OSBGecisKontrolSistemi = lazy(() => import('../pages/hizmetlerimiz/osb-gecis-kontrol-sistemi/page'));
const AcilFiberArizaMudahalesi = lazy(() => import('../pages/hizmetlerimiz/acil-fiber-ariza-mudahalesi/page'));

// ESKİ Service Projects
const FactoryFiberInfrastructurePage = lazy(() => import('../pages/services/factory-fiber-infrastructure/page'));
const IndustrialCameraSystemPage = lazy(() => import('../pages/services/industrial-camera-system/page'));
const MetroEthernetFiberPage = lazy(() => import('../pages/services/metro-ethernet-fiber/page'));
const BuildingFireAlarmSystemPage = lazy(() => import('../pages/services/building-fire-alarm-system/page'));
const OSBAccessControlSystemPage = lazy(() => import('../pages/services/osb-access-control-system/page'));
const EmergencyFiberRepairPage = lazy(() => import('../pages/services/emergency-fiber-repair/page'));

// Locations
const IstanbulAvrupaPage = lazy(() => import('../pages/locations/istanbul-avrupa/page'));
const IstanbulAnadoluPage = lazy(() => import('../pages/locations/istanbul-anadolu/page'));
const TuzlaPage = lazy(() => import('../pages/locations/tuzla/page'));
const GebzePage = lazy(() => import('../pages/locations/gebze/page'));
const DilovasiPage = lazy(() => import('../pages/locations/dilovasi/page'));
const CayirovaPage = lazy(() => import('../pages/locations/cayirova/page'));
const KocaeliPage = lazy(() => import('../pages/locations/kocaeli/page'));
const SakaryaPage = lazy(() => import('../pages/locations/sakarya/page'));
const YalovaPage = lazy(() => import('../pages/locations/yalova/page'));
const BursaPage = lazy(() => import('../pages/locations/bursa/page'));
const TekirdagPage = lazy(() => import('../pages/locations/tekirdag/page'));
const CorluPage = lazy(() => import('../pages/locations/corlu/page'));
const AtasehirPage = lazy(() => import('../pages/locations/atasehir/page'));
const KadikoyPage = lazy(() => import('../pages/locations/kadikoy/page'));
const UmraniyePage = lazy(() => import('../pages/locations/umraniye/page'));
const EsenyurtPage = lazy(() => import('../pages/locations/esenyurt/page'));
const BasaksehirPage = lazy(() => import('../pages/locations/basaksehir/page'));
const PendikPage = lazy(() => import('../pages/locations/pendik/page'));
const KartalPage = lazy(() => import('../pages/locations/kartal/page'));
const BeylikduzuPage = lazy(() => import('../pages/locations/beylikduzu/page'));

// Blog pages - existing routes
const BlogPage = lazy(() => import('../pages/blog/page'));
const FiberKabloTamiri = lazy(() => import('../pages/blog/fiber-optik-kablo-tamiri-nasil-yapilir/page'));
const FusionSplicing = lazy(() => import('../pages/blog/fusion-splicing-nedir/page'));
const OtdrTesti = lazy(() => import('../pages/blog/otdr-testi-nedir/page'));
const IpKameraSecimi = lazy(() => import('../pages/blog/ip-kamera-secim-rehberi/page'));
const FabrikaFiberRehberi = lazy(() => import('../pages/blog/fabrikalarda-fiber-altyapi-rehberi/page'));
const YanlisFiberOnarim = lazy(() => import('../pages/blog/yanlislikla-kesilen-fiber-kablo-nasil-onarilir/page'));

// New Blog pages
const HirsizAlarmSistemi = lazy(() => import('../pages/blog/hirsiz-alarm-sistemi-calisma-mantigi/page'));
const YanginAlarmYonetmelik = lazy(() => import('../pages/blog/yangin-alarm-yonetmelikleri/page'));
const BariyerTurnikeSistem = lazy(() => import('../pages/blog/bariyer-turnike-sistemleri-kullanim-alanlari/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  // Fiber Services
  {
    path: '/fiber-hizmetleri',
    element: <FiberServicesPage />,
  },
  {
    path: '/fiber-hizmetleri/fiber-kablo-tamiri',
    element: <FiberCableRepairPage />,
  },
  {
    path: '/fiber-hizmetleri/fiber-sonlandirma',
    element: <FiberTerminationPage />,
  },
  {
    path: '/fiber-hizmetleri/otdr-test',
    element: <OTDRTestPage />,
  },
  {
    path: '/fiber-hizmetleri/bina-fiber-altyapi',
    element: <BuildingFiberPage />,
  },
  {
    path: '/fiber-hizmetleri/fabrika-fiber',
    element: <FactoryFiberPage />,
  },
  {
    path: '/fiber-hizmetleri/acil-servis',
    element: <EmergencyServicePage />,
  },
  // Security Systems
  {
    path: '/guvenlik-sistemleri',
    element: <SecuritySystemsPage />,
  },
  {
    path: '/guvenlik-sistemleri/ip-kamera-sistemleri',
    element: <IPCameraSystemsPage />,
  },
  {
    path: '/guvenlik-sistemleri/hirsiz-alarm-sistemleri',
    element: <BurglarAlarmSystemsPage />,
  },
  {
    path: '/guvenlik-sistemleri/yangin-alarm-sistemleri',
    element: <FireAlarmSystemsPage />,
  },
  {
    path: '/guvenlik-sistemleri/gecis-kontrol-sistemleri',
    element: <AccessControlSystemsPage />,
  },
  {
    path: '/guvenlik-sistemleri/bariyer-sistemleri',
    element: <BarrierSystemsPage />,
  },
  {
    path: '/guvenlik-sistemleri/turnike-sistemleri',
    element: <TurnstileSystemsPage />,
  },
  // YENİ Hizmetlerimiz Sayfaları
  {
    path: '/hizmetlerimiz/fabrika-fiber-altyapi-projesi',
    element: <FabrikaFiberAltyapiProjesi />,
  },
  {
    path: '/hizmetlerimiz/sanayi-bolgesi-kamera-sistemi',
    element: <SanayiBolgesiKameraSistemi />,
  },
  {
    path: '/hizmetlerimiz/metro-ethernet-fiber-ek',
    element: <MetroEthernetFiberEk />,
  },
  {
    path: '/hizmetlerimiz/bina-yangin-alarm-sistemi',
    element: <BinaYanginAlarmSistemi />,
  },
  {
    path: '/hizmetlerimiz/osb-gecis-kontrol-sistemi',
    element: <OSBGecisKontrolSistemi />,
  },
  {
    path: '/hizmetlerimiz/acil-fiber-ariza-mudahalesi',
    element: <AcilFiberArizaMudahalesi />,
  },
  // ESKİ Service Projects (eski URL'ler için backward compatibility)
  {
    path: '/services/factory-fiber-infrastructure',
    element: <FactoryFiberInfrastructurePage />,
  },
  {
    path: '/services/industrial-camera-system',
    element: <IndustrialCameraSystemPage />,
  },
  {
    path: '/services/metro-ethernet-fiber',
    element: <MetroEthernetFiberPage />,
  },
  {
    path: '/services/building-fire-alarm-system',
    element: <BuildingFireAlarmSystemPage />,
  },
  {
    path: '/services/osb-access-control-system',
    element: <OSBAccessControlSystemPage />,
  },
  {
    path: '/services/emergency-fiber-repair',
    element: <EmergencyFiberRepairPage />,
  },
  // Locations
  {
    path: '/bolgeler/istanbul-avrupa',
    element: <IstanbulAvrupaPage />,
  },
  {
    path: '/bolgeler/istanbul-anadolu',
    element: <IstanbulAnadoluPage />,
  },
  {
    path: '/bolgeler/tuzla',
    element: <TuzlaPage />,
  },
  {
    path: '/bolgeler/gebze',
    element: <GebzePage />,
  },
  {
    path: '/bolgeler/dilovasi',
    element: <DilovasiPage />,
  },
  {
    path: '/bolgeler/cayirova',
    element: <CayirovaPage />,
  },
  {
    path: '/bolgeler/kocaeli',
    element: <KocaeliPage />,
  },
  {
    path: '/bolgeler/sakarya',
    element: <SakaryaPage />,
  },
  {
    path: '/bolgeler/yalova',
    element: <YalovaPage />,
  },
  {
    path: '/bolgeler/bursa',
    element: <BursaPage />,
  },
  {
    path: '/bolgeler/tekirdag',
    element: <TekirdagPage />,
  },
  {
    path: '/bolgeler/corlu',
    element: <CorluPage />,
  },
  {
    path: '/bolgeler/atasehir',
    element: <AtasehirPage />,
  },
  {
    path: '/bolgeler/kadikoy',
    element: <KadikoyPage />,
  },
  {
    path: '/bolgeler/umraniye',
    element: <UmraniyePage />,
  },
  {
    path: '/bolgeler/esenyurt',
    element: <EsenyurtPage />,
  },
  {
    path: '/bolgeler/basaksehir',
    element: <BasaksehirPage />,
  },
  {
    path: '/bolgeler/pendik',
    element: <PendikPage />,
  },
  {
    path: '/bolgeler/kartal',
    element: <KartalPage />,
  },
  {
    path: '/bolgeler/beylikduzu',
    element: <BeylikduzuPage />,
  },
  // Blog
  {
    path: '/blog',
    element: <BlogPage />,
  },
  {
    path: '/blog/fiber-optik-kablo-tamiri-nasil-yapilir',
    element: <FiberKabloTamiri />,
  },
  {
    path: '/blog/otdr-testi-nedir',
    element: <OtdrTesti />,
  },
  {
    path: '/blog/yanlislikla-kesilen-fiber-kablo-nasil-onarilir',
    element: <YanlisFiberOnarim />,
  },
  {
    path: '/blog/fabrikalarda-fiber-altyapi-rehberi',
    element: <FabrikaFiberRehberi />,
  },
  {
    path: '/blog/fusion-splicing-nedir',
    element: <FusionSplicing />,
  },
  {
    path: '/blog/ip-kamera-secim-rehberi',
    element: <IpKameraSecimi />,
  },
  {
    path: '/blog/hirsiz-alarm-sistemi-calisma-mantigi',
    element: <HirsizAlarmSistemi />,
  },
  {
    path: '/blog/yangin-alarm-yonetmelikleri',
    element: <YanginAlarmYonetmelik />,
  },
  {
    path: '/blog/bariyer-turnike-sistemleri-kullanim-alanlari',
    element: <BariyerTurnikeSistem />,
  },
  // Contact
  {
    path: '/iletisim',
    element: <ContactPage />,
  },
  // KVKK
  {
    path: '/kvkk',
    element: <KVKKPage />,
  },
  // 404
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;